import { Routes, Route } from "react-router-dom";
import PrivateRoutes from "./utils/PrivateRoute";
import Error404 from "./components/Error404";
import Main from "./apps/Main/pages/Main";
import LoginUser from "./apps/Auth/pages/LoginUser";
import CreateUser from "./apps/Auth/pages/CreateUser";
import Users from "./apps/Users/pages/Users";
import Items from "./apps/Items/pages/Items";
import ItemDetail from "./apps/Items/pages/ItemDetail";
import AddItems from "./apps/Items/pages/AddItems";
import Suggestion from "./apps/Suggestions/pages/Suggestions";
import Distributors from "./apps/Distributors/pages/Distributors";
import Regions from "./apps/Regions/pages/Regions";
import AddRegion from "./apps/Regions/pages/AddRegion";
import Offer from "./apps/Offers/pages/Offer";
import Circulars from "./apps/Circulars/pages/Circulars";
import Orders from "./apps/Orders/pages/Orders";
import OrderDetail from "./apps/Orders/pages/OrderDetail";
import PrivateRoutePrinter from "./utils/PrivateRoutePrinter";
import AddItemLevel2 from "./apps/Items/pages/AddItemLevel2";

// App Page with All Router
export default function App() {
  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<LoginUser />} />

      {/* private route required auth user */}
      <Route element={<PrivateRoutes />}>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<Main />} />
        <Route path={`${process.env.PUBLIC_URL}/users`} element={<Users />} />
        <Route path={`${process.env.PUBLIC_URL}/create-user`} element={<CreateUser />} />
        <Route path={`${process.env.PUBLIC_URL}/items`} element={<Items />} />
        <Route path={`${process.env.PUBLIC_URL}/add-item`} element={<AddItems />} />
        <Route path={`${process.env.PUBLIC_URL}/item/:itemId`} element={<ItemDetail />} />
        <Route path={`${process.env.PUBLIC_URL}/item/:itemId/add`} element={<AddItemLevel2 />} />
        <Route path={`${process.env.PUBLIC_URL}/suggestions`} element={<Suggestion />} />
        <Route path={`${process.env.PUBLIC_URL}/distributors`} element={<Distributors />} />
        <Route path={`${process.env.PUBLIC_URL}/regions`} element={<Regions />} />
        <Route path={`${process.env.PUBLIC_URL}/add-region`} element={<AddRegion />} />
        <Route path={`${process.env.PUBLIC_URL}/send-offer`} element={<Offer />} />
        <Route path={`${process.env.PUBLIC_URL}/send-circular`} element={<Circulars />} />
        <Route path={`${process.env.PUBLIC_URL}/orders`} element={<Orders />} />
        {/* <Route
          path={`${process.env.PUBLIC_URL}/notifications`}
          element={<Notifications />}
        /> */}
        <Route path="*" element={<Error404 />} />
      </Route>
      <Route element={<PrivateRoutePrinter />}>
        <Route path={`${process.env.PUBLIC_URL}/orders/:orderId`} element={<OrderDetail />} />
      </Route>
    </Routes>
  );
}
